import React from 'react';
import { Loader2 } from 'lucide-react';

interface Props {
  titel?: string;
  text: string;
  jaText: string;
  /** Rot statt Teal — fuer Loeschen und Verwerfen. */
  gefaehrlich?: boolean;
  /** Laufender Vorgang: beide Knoepfe gesperrt, Klick daneben schliesst nicht. */
  laeuft?: boolean;
  /** Dritter Weg neben Abbrechen und Ja, z. B. „Gespeicherten Stand testen". */
  alternative?: { text: string; onWahl: () => void };
  onJa: () => void;
  onNein: () => void;
}

/**
 * Rueckfrage in der App statt `window.confirm` — der Browser-Dialog
 * blockiert die Seite und sieht auf jedem System anders aus (CI-Ratsche).
 * Der Fokus steht auf „Abbrechen": ein versehentliches Enter loescht nichts.
 */
export const RueckfrageDialog: React.FC<Props> = ({ titel, text, jaText, gefaehrlich = false, laeuft = false, alternative, onJa, onNein }) => (
  <div
    className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
    onClick={laeuft ? undefined : onNein}
    onKeyDown={(e) => { if (e.key === 'Escape' && !laeuft) onNein(); }}
    role="presentation"
  >
    <div
      role="alertdialog"
      aria-modal="true"
      aria-label={titel || 'Rückfrage'}
      className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-5 space-y-4"
      onClick={(e) => e.stopPropagation()}
    >
      {titel && <h3 className="text-sm font-bold text-slate-800">{titel}</h3>}
      <p className="text-sm text-slate-700 whitespace-pre-line">{text}</p>
      <div className="flex flex-wrap justify-end gap-2">
        <button
          type="button"
          autoFocus
          onClick={onNein}
          disabled={laeuft}
          className="min-h-[44px] px-4 text-sm font-bold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors disabled:opacity-40"
        >
          Abbrechen
        </button>
        {alternative && (
          <button
            type="button"
            onClick={alternative.onWahl}
            disabled={laeuft}
            className="min-h-[44px] px-4 text-sm font-bold text-teal-700 bg-teal-50 hover:bg-teal-100 rounded-xl transition-colors disabled:opacity-40"
          >
            {alternative.text}
          </button>
        )}
        <button
          type="button"
          onClick={onJa}
          disabled={laeuft}
          className={`min-h-[44px] px-4 flex items-center gap-2 text-sm font-bold text-white rounded-xl transition-colors disabled:opacity-40 ${gefaehrlich ? 'bg-red-600 hover:bg-red-700' : 'bg-teal-600 hover:bg-teal-700'}`}
        >
          {laeuft && <Loader2 className="w-4 h-4 animate-spin" />} {jaText}
        </button>
      </div>
    </div>
  </div>
);
